import React from 'react';

import { Fade, Typography } from '@mui/material';
import CloseButton from 'components/CloseButton';
import ColorPicker from 'components/ColorPicker';
import useAnchorEl from 'hooks/useAnchorEl';

import {
	StyledProfilePopoverColorPickerItemColor,
	StyledProfilePopoverColorPickerItemWrap,
	StyledProfilePopoverColorPickerWrap,
} from './styled';

type PropsType = {
	label: string;
	colors: string[] | string;
	onChange: (value: string) => void;
	background: string;
};

function ProfilePopoverColorPicker({ label, colors, onChange, background }: PropsType) {
	const { open, handleClose, handleOpen, anchorEl } = useAnchorEl();

	return (
		<>
			<StyledProfilePopoverColorPickerItemWrap tabIndex={0} onClick={handleOpen}>
				<Typography>{label}</Typography>
				<StyledProfilePopoverColorPickerItemColor sx={{ background }} />
			</StyledProfilePopoverColorPickerItemWrap>
			<StyledProfilePopoverColorPickerWrap
				TransitionComponent={Fade}
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				onClose={handleClose}
			>
				<CloseButton
					onClick={handleClose}
					sx={{ marginBottom: '8px', float: 'inline-end' }}
					size="small"
					color="inherit"
				/>
				<ColorPicker colors={colors} onChange={onChange} />
			</StyledProfilePopoverColorPickerWrap>
		</>
	);
}

export default ProfilePopoverColorPicker;
